<template>
  <section class="change-password-content">
    <div class="main">
      <div class="first">
        <h3>{{changePassword_}}</h3>
        <div v-show="!reset_pw" class="">
          {{password_}}*
          <br/>
          <input type="password" v-model="pwd" @keypress.enter="submit"/>
        </div>
        <div class="">
          {{newPwd_}}*
          <br/>
          <input type="password" v-model="new_pwd" @keypress.enter="submit"/>
        </div>
        <div class="">
          {{retypePwd_}}*
          <br/>
          <input type="password" v-model="new_pwd_ag" @keypress.enter="submit"/>
        </div>
        <div class="buttons">
          <div class="error">{{msg}}</div>
          <a class="btn btn-large" @click="submit">{{submit_}}</a>
          <a class="btn btn-large" @click="reset">{{reset_}}</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { hash } from '@/utils'
  import { passwd } from '@/utils/api.js'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        reset_pw: false,
        pwd: '',
        new_pwd: '',
        new_pwd_ag: '',
        msg: '',
        username: ''
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale']),
      ...mapGetters([]),
      ...i18n.map([
        'changePassword_', 'password_', 'newPwd_',
        'retypePwd_', 'submit_', 'reset_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      submit () {
        if (this.new_pwd !== this.new_pwd_ag) {
          this.msg = this.i18n.notMatch
          return
        }

        let oldpass = ''
        if (this.reset_pw) oldpass = this.$route.query.token
        else oldpass = hash(this.username, this.pwd)

        passwd(this.username, oldpass, hash(this.username, this.new_pwd))
          .then((data) => {
            this.$emit('msg', {
              msg: data.msg,
              type: 'info',
              delay: 2000,
              callback: () => {
                this.profile.name = this.profile.name || this.username
                this.$router.push('/profile')
              }
            })
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      reset () {
        this.pwd = ''
        this.new_pwd = ''
        this.new_pwd_ag = ''
      }
    },
    created () {
      let {name, token} = this.$route.query
      if (name && token) {
        this.reset_pw = true
      } else name = this.profile.name
      if (!name) {
        this.$router.replace('/login')
        return
      }

      this.username = name
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/change_pwd.vue